import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import vid from "../../Assets/video-editing.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import { Player } from "@lottiefiles/react-lottie-player";
import lot2 from '../../Assets/lottie/android-servc.json'
import lot3 from '../../Assets/lottie/logo-servc.json'
import lot4 from '../../Assets/lottie/web-srvc.json'
import lot5 from '../../Assets/lottie/voiceocr-srvc.json'
import lot6 from '../../Assets/lottie/video-srvc.json'
import lot7 from '../../Assets/lottie/webrpair-srvc.json'
function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
         <strong className="purple">Habzon </strong>Freelancing Services
        </h1>
        <p style={{ color: "white" }}>
        Freelancing Services
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
         

          <Col md={4} className="project-card white">
          <Player
        src={lot3}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={1}
        style={{ height: '300px', width: '300px' }}

      />
      
      <h1 className="white">Logo Design</h1>
      <h1 className="white">ሎጎ ዲዛይን </h1>
          </Col>

          <Col md={4} className="project-card">
          <Player
        src={lot2}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={1}
        style={{ height: '300px', width: '300px' }}

      />
      <h1 className="white">Mobile App </h1>
      <h1 className="white">ሞባይል አፕ </h1>
          </Col>

          <Col md={4} className="project-card">
          <Player
        src={lot4}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={1}
        style={{ height: '300px', width: '300px' }}

      />
      <h1 className="white">Web Design </h1>
      <h1 className="white">ዌብሳይት ዲዛይን </h1>
          </Col>

          <Col md={4} className="project-card">
          <Player
        src={lot5}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={1}
        style={{ height: '300px', width: '300px' }}

      />
      <h2 className="white-text"><b>Voice Over </b></h2>
      <h1 className="white">ድምጺ ምምላእ </h1>
          </Col>

          <Col md={4} className="project-card">
          <Player
        src={lot6}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={1}
        style={{ height: '300px', width: '300px' }}

      />
        <h1 className="white">Video Editing </h1>
      <h1 className="white">ቪድዮ ኤዲቲንግ </h1>
          </Col>
          <Col md={4} className="project-card">
          <Player
        src={lot7}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={1}
        style={{ height: '300px', width: '300px' }}

      />
      <h1 className="white">Other... </h1>
      <h1 className="white">ካልእን... </h1>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
